import { Pin } from '@lessonup/pins-shared';
import { createContext, useContext } from 'react';

/**
 * Context that provides the pin object.
 * Used for PinComponents (like the AnswerAreaPinComponent) that need information about the pin,
 * without passing the pin as a prop, to prevent unnecessary re-renders.
 * This setup does not break the `memo()` function used in PinComponentSwitch.
 */
export const PinContext = createContext<Pin | null>(null);

/**
 * Hook to get the pin object from the context
 *
 * @returns the pin object
 */
export function usePinContext(): Pin {
  const pin = useContext(PinContext);
  if (!pin) {
    throw new Error('PinContext not found');
  }
  return pin;
}
